const Translate = () => {

    function change_language(language) {
        const value = `/auto/${language}`;
        const hostname = window.location.hostname;

        // Sempre funciona
        document.cookie = `googtrans=${value};path=/`;

        // Só adiciona domain fora de localhost
        if (hostname !== "localhost" && hostname !== "127.0.0.1") {
            document.cookie = `googtrans=${value};path=/;domain=${hostname}`;
        }

        localStorage.setItem('language-abbreviation', language);

        // Reload necessário pro Google aplicar tradução
        window.location.reload();
    }

    function addEvent() {
        const selectsLang = document.querySelectorAll('.box-lang li');

        selectsLang.forEach((li) => {
            li.onclick = null;

            li.onclick = (e) => {
                e.preventDefault();

                const text = e.currentTarget.textContent
                    .trim()
                    .toLowerCase();

                change_language(text);
            };
        });
    }

    function initTranslate() {

        window.googleTranslateElementInit = function () {
            new google.translate.TranslateElement({
                pageLanguage: 'pt',
                includedLanguages: 'pt,en,es',
                autoDisplay: false,
            }, 'google_translate_element');
        };

        if (!document.getElementById("google-translate-script")) {
            const script = document.createElement("script");
            script.id = "google-translate-script";
            script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
            script.async = true;
            document.body.appendChild(script);
        }
    }

    function main() {
        addEvent();
        initTranslate();
    }

    if (document.readyState === 'complete') {
        main();
    } else {
        window.addEventListener('load', main);
    }
}

export default Translate;